import './InfoTooltip.less';

import { Tooltip } from 'antd';
import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface InfoTooltipProps {
  content: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ content }) => {
  return (
    <div className="info-tooltip">
      <Tooltip title={content}>
        <ExclamationCircleOutlined className="info-tooltip-icon" />
      </Tooltip>
    </div>
  );
};

export default InfoTooltip;
